import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GenericDialogComponent, GenericDialogData, GenericDialogResult } from '@app/shared/components/generic-dialog';
import { take } from 'rxjs/operators';
import { DialogDefaultConfig } from '../configs/dialog.config';



@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(public dialog: MatDialog,) { }

  openConfirmDialog(title: string, message: string, callBackOnSuccess: () => void) {
    this.openGenericConfirmDialog({ title, message }, callBackOnSuccess);
  }

  openDialog<C, D, R>(component: ComponentType<C>, data: D, callBackOnSuccess: (data?: R) => void) {
    const dialogRef = this.dialog.open(component, {
      data: data,
      ...DialogDefaultConfig
    });

    dialogRef.afterClosed().pipe(
      take(1)
    ).subscribe((response: CustomDialogResult<R>) => {
      if (response.status == GenericDialogResult.Cancel) return;
      callBackOnSuccess(response.resultData)
    });
  }

  openGenericConfirmDialog(
    data: GenericDialogData,
    callBackOnSuccess: () => void
  ) {
    const dialogData: GenericDialogData = {
      ...data,
      buttons: data.buttons?.length ? data.buttons : [
        { text: 'Cancel', action: 'cancel' },
        { text: 'Confirm', action: 'confirm', color: 'primary' }
      ]
    };
    const dialogRef = this.dialog.open(GenericDialogComponent, {
      ...DialogDefaultConfig,
      data: dialogData
    });

    dialogRef.afterClosed().pipe(
      take(1)
    ).subscribe((result: GenericDialogResult) => {
      if (result === GenericDialogResult.Confirm) {
        callBackOnSuccess();
      }
    });
  }

  openGenericDialog<T = void>(data: GenericDialogData, callBackOnSuccess: (result?: T) => void) {
    const dialogRef = this.dialog.open(GenericDialogComponent, {
      ...DialogDefaultConfig,
      data
    });

    dialogRef.afterClosed().pipe(
      take(1)
    ).subscribe((result: GenericDialogResult | T) => {
      if (result === GenericDialogResult.Confirm || (result && typeof result !== 'number')) {
        callBackOnSuccess(result as T);
      }
    });
  }
}

export interface CustomDialogResult<R> {
  status: GenericDialogResult;
  resultData: R;
}
